import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from '../../shared/app-settings/app-settings.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

	public staticPath;

  constructor(
    public appSettings: AppSettingsService,
  ) {}

  ngOnInit () {
		this.staticPath = environment.staticPath;
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/header/header.component.ts